module.exports = __webpack_public_path__ + "images/mp3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3.png
// module id = 962
// module chunks = 2